import { useMutation, MutationHookOptions } from '@apollo/client';
import MUTATION from '../operations/UpdateGeminiThreadName.graphql';
import { Mutation, MutationupdateGeminiThreadNameArgs } from '../../__generated__/globalTypes';

export const useUpdateGeminiThreadNameMutation = (
  options?: MutationHookOptions<Mutation, MutationupdateGeminiThreadNameArgs>
) => {
  const [callUpdateGeminiThreadName, result] = useMutation<Mutation, MutationupdateGeminiThreadNameArgs>(
    MUTATION,
    options
  );

  return { callUpdateGeminiThreadName, ...result };
};

export type UpdateGeminiThreadNameMutationFunction = Mutation['updateGeminiThreadName'];
